export default __webpack_public_path__ + "static/media/bg7.3419d02b.jpg";